import { Controller } from "@hotwired/stimulus";
import { acceptListToString, isValidType } from "../javascripts/is_valid_type";

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["button", "file", "preview", "removeFile", "fileName"];

  connect() {
    this.fileTarget.addEventListener("change", this.updatePreview.bind(this));
  }

  trigger() {
    this.fileTarget.click();
  }

  updatePreview(e) {
    // サイズとフォーマットが不正ならアラートしてキャンセル
    const file = this.fileTarget.files[0];
    if (!this.#isValid(file)) {
      this.fileTarget.value = null;
      e.preventDefault();
      return;
    }

    this.removeFileTarget.value = "0";
    if (file.type === "image/heic" || file.type === "image/heif") {
      this.displayFileName(file);
    } else if (file.type.startsWith("image/")) {
      this.displayImage(file);
    } else {
      this.displayFileName(file);
    }
  }

  displayImage(file) {
    const url = URL.createObjectURL(file);
    this.previewTarget.src = url;
    this.previewTarget.closest(".file-upload-image").setAttribute("aria-hidden", "false");
    this.buttonTarget.setAttribute("aria-disabled", "true");
    this.removeFileTarget.value = "0";
  }

  displayFileName(file) {
    const fileName = file.name;
    this.fileNameTarget.textContent = fileName;
    this.fileNameTarget.closest(".file-upload-name").setAttribute("aria-hidden", "false");
    this.buttonTarget.setAttribute("aria-disabled", "true");
    this.removeFileTarget.value = "0";
  }

  deleteImage(event) {
    event.preventDefault();
    this.buttonTarget.setAttribute("aria-disabled", "false");
    this.previewTarget.src = "";
    this.previewTarget.closest(".file-upload-image").setAttribute("aria-hidden", "true");
    this.removeFileTarget.value = "1";
    this.fileTarget.value = "";
  }

  deleteFile(event) {
    event.preventDefault();
    this.buttonTarget.setAttribute("aria-disabled", "false");
    this.fileNameTarget.src = "";
    this.fileNameTarget.closest(".file-upload-name").setAttribute("aria-hidden", "true");
    this.removeFileTarget.value = "1";
    this.fileTarget.value = "";
  }

  #isValid(file) {
    if (!file) return false;

    // acceptと比較
    const accept = this.fileTarget.accept;
    if (!isValidType(file, accept)) {
      this.fileTarget.value = ""; // 入力をクリア
      const acceptList = acceptListToString(accept);
      alert(`ファイル形式は${acceptList} 形式のファイルを設定してください。`);
      return false;
    }

    // サイズ制限
    const maxSize = this.fileTarget.dataset.maxSize;
    const size = file.size;
    if (maxSize && maxSize < size) {
      const mb = maxSize / 1024 / 1024;
      this.fileTarget.value = ""; // 入力をクリア
      alert(`${mb}MB以内でアップロードしてください。`);
      return false;
    }
    return true;
  }
}
